export default __webpack_public_path__ + "static/media/laptop and mobile.e5603e44.jpg";